import { render, staticRenderFns } from "./NewInquiryModal.vue?vue&type=template&id=39362c23&"
import script from "./NewInquiryModal.vue?vue&type=script&lang=ts&"
export * from "./NewInquiryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports